// extracted by mini-css-extract-plugin
module.exports = {"Title":"Success_Title__3L6j3","Subtitle":"Success_Subtitle__2nZM2","Image":"Success_Image__39j0r"};